export default function UserIcon() {
  return (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30 30C36.9036 30 42.5 24.4036 42.5 17.5C42.5 10.5964 36.9036 5 30 5C23.0964 5 17.5 10.5964 17.5 17.5C17.5 24.4036 23.0964 30 30 30Z"
        strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M51.4749 55C51.4749 45.325 41.8499 37.5 29.9999 37.5C18.1499 37.5 8.5249 45.325 8.5249 55"
            strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
